import { Injectable } from "@angular/core";
import { CompanyService, PermissionCategoryDto, PermissionTypeDto } from "clearline-api";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

const POS_SETTINGS_PERMISSION_MAP = {
  posModes: PermissionTypeDto.PosSettingsPosModes,
  loyalty: PermissionTypeDto.PosSettingsLoyalty,
  coupons: PermissionTypeDto.PosSettingsCoupons,
  posRules: PermissionTypeDto.PosSettingsPosRules,
  receiptMarketing: PermissionTypeDto.PosSettingsReceiptMarketing,
  syncEditable: PermissionTypeDto.PosSettingsSyncEditable
} as const;

export type PosSettingsPermissions = Record<keyof typeof POS_SETTINGS_PERMISSION_MAP, boolean>;

@Injectable({
  providedIn: "root"
})
export class PosSettingsPermissionsService {
  constructor(private companyService: CompanyService) {}

  get emptyPermissions(): PosSettingsPermissions {
    return this.mapPermissions([]);
  }

  getPermissions(): Observable<PosSettingsPermissions> {
    return this.companyService
      .getPermissionsByCategory(PermissionCategoryDto.PosSettingsConfiguration)
      .pipe(map(({ permissions }) => this.mapPermissions(permissions)));
  }

  private mapPermissions(permissions: PermissionTypeDto[]): PosSettingsPermissions {
    const granted = new Set(permissions);

    return Object.entries(POS_SETTINGS_PERMISSION_MAP).reduce(
      (acc, [key, permission]) => ({ ...acc, [key]: granted.has(permission) }),
      {} as PosSettingsPermissions
    );
  }
}
